module.exports = __webpack_public_path__ + "media/images/common/ico-apply-8cec3fc1af9cf4db8b0007ee7d6c3fb2.svg";